export default "__VITE_ASSET__BpaELv5G__"